import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SET_IS_CURATION_ENABLED_INGREDIENT_MUTATION } from '../graphql/mutations'
import { SET_IS_CURATION_ENABLED_INGREDIENT } from '../redux/action-types'

const useSetIsCurationEnabledIngredientMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredients,
  )

  const mutate = useCallback(
    async (id, isCurationEnabled) => {
      await apolloService.mutate(
        SET_IS_CURATION_ENABLED_INGREDIENT_MUTATION,
        {
          id,
          isCurationEnabled,
        },
        dispatch,
        SET_IS_CURATION_ENABLED_INGREDIENT,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSetIsCurationEnabledIngredientMutation
